export const INIT_LOGIN = 'accionInitLogin';
export const FINISH_LOGIN = 'accionFinishLogout';

export const initLogin = () => ({
    type: INIT_LOGIN
});

export const finishLogin = () => ({
    type: FINISH_LOGIN
});